import Process from 'images/ecom/process/Process1.png'
import Process2 from 'images/ecom/process/Process2.jpg'
import Process3 from 'images/ecom/process/Process3.jpg'
import Process4 from 'images/ecom/process/Process4.png'

export const ourProcessHowItWorksSteps = [
  {
    image: Process,
    title: 'We send you an Artkive box',
    body: "The Artkive box is more than a box: it's the beginning of your Artkive experience. It's sturdy, insured, and large enough to safely send us a lot of art (for multiple kids, too!). Once you order a box, it's time to fill it up! Bring on the joyful memories.",
  },
  {
    image: Process2,
    title: 'Our creative process begins',
    body: "Once we get your Artkive box back to our studio, we get to work doing what we love! We'll professionally photograph and edit each piece with studio lighting and state-of-the-art equipment. Once everything is beautifully captured, we'll send you an invoice based on the number of pieces you sent.",
  },
  {
    image: Process3,
    title: "It's time to collaborate",
    body: "Our design team creates a digital proof of your art book or framed mosaic, then sends it to you so you can review, edit if needed, and ultimately approve. Once you give us the green light, we'll send your proof to press!",
  },
  {
    image: Process4,
    title: 'Your art is Artkived!',
    body: "We send your custom keepsake to you (with free shipping, as always). We'll also send back your art if you've selected that option at checkout. If not, we'll responsibly recycle it. It's time to place your beautiful new art book on your coffee table, framed mosaic in a place of honor, and enjoy! At this point we recommend collective high-fives, hugs, and major pats on the back. You did it! ",
  },
]
